import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { useSelector } from "react-redux";
import AccountInfo from "./AccountInfo";
import Scores from "./Scores";
import Orders from "./Orders";
import Address from "./Address";
import Photos from "./Photos";
import Messages from "./Messages";
import Favourites from "./Favourites";
import Performance from "./Performance";
import Dashboard from "./Dashboard";
import Waybill from "./Waybill";
import SendIdea from "./SendIdea";
import Badges from "./Badges";

// react-icons
import {
  FaUser,
  FaShoppingBag,
  FaStar,
  FaGamepad,
  FaEnvelope,
  FaHeart,
  FaChartBar,
  FaUserCog,
  FaMedal,
  FaUsers,
} from "react-icons/fa";
import BrandOrders from "./Orders/BrandOrders";
import LoginDetails from "./LoginDetails";
import CharityScore from "./Scores/CharityScore";
import CodeEntry from "./CodeEntry";
import ReceiptScan from "./ReceiptScan";
import ReceiptList from "./ReceiptList";
import LandingPage2 from "@/pages/public/LandingPage2";
import CommunicationPreferences from "./CommunicationPreferences";
import InformationText from "./InformationText";
import MyReferences from "./MyReferences";
import ConnectedChefs from "./ConnectedChefs";

// config
import { isCharityScoreEnabled } from "@config/app.config";

const ProfileTest = () => {
  const location = useLocation();
  const profileDetail = useSelector((store) => store.profile.profileDetail);
  const profilePhoto = useSelector((store) => store.profile.profilePhoto);
  const tenantMenuObjects = useSelector((store) => store.profile.tenantMenu);
  // BRAND_PRODUCTS_SALES_MODE: false ise marka ürünleri satışa kapalı,
  // "Ürünlerim" (/profile/brand-orders) menüsü gizlenir.
  const brandSalesMode = useSelector((store) => store.brand.brandSalesMode);
  const isBrandSalesEnabled = brandSalesMode !== false;
  const [page, setPage] = React.useState("accountInfo");
  const [profilePhotoItem, setProfilePhotoItem] = useState(null);
  const [selectedItem, setSelectedItem] = useState("/profile/account-info");
  const [expandedGroup, setExpandedGroup] = useState(null);

  const hiddenProfileMenus = React.useMemo(() => {
    if (tenantMenuObjects && Array.isArray(tenantMenuObjects)) {
      return tenantMenuObjects.map((item) => item?.menu?.pathUrl || "");
    }
    return [];
  }, [tenantMenuObjects]);

  useEffect(() => {
    const currentPage = location.pathname.split("/")[2];
    setPage(currentPage);
    setSelectedItem(location.pathname);

    // Seçili sayfaya göre ilgili grubu otomatik aç
    const groupToExpand = getGroupForPage(currentPage);
    if (groupToExpand) {
      setExpandedGroup(groupToExpand);
    }
  }, [location]);

  useEffect(() => {
    if (profilePhoto) {
      for (let i = 0; i < profilePhoto.length; i++) {
        if (
          profilePhoto[i].imageStatus === "APPROVED" &&
          profilePhoto[i].employeeImageContentType === "PROFILE"
        ) {
          setProfilePhotoItem(profilePhoto[i]);
        }
      }
    }

    return () => {};
  }, [profilePhoto]);

  const getGroupForPage = (page) => {
    const pageToGroupMap = {
      orders: "siparislerim",
      "brand-orders": "siparislerim",
      scores: "puanlarim",
      "charity-scores": "puanlarim",
      "receipt-scan": "oyunlarim",
      "code-entry": "oyunlarim",
      "send-idea": "oyunlarim",
      messages: "mesajlarim",
      favourites: "favorilerim",
      performance: "performans-bilgilerim",
      dashboard: "performans-bilgilerim",
      "my-references": "arkadasini-getir",
      "connected-chefs": "bagli-ustalar",
      "account-info": "hesap-bilgilerim",
      "login-details": "hesap-bilgilerim",
      photos: "hesap-bilgilerim",
      address: "hesap-bilgilerim",
      "communication-preferences": "hesap-bilgilerim",
    };
    return pageToGroupMap[page];
  };

  const toggleGroup = (groupKey) => {
    setExpandedGroup((prev) => (prev === groupKey ? null : groupKey));
  };

  const menuGroups = [
    {
      key: "siparislerim",
      title: "Siparişlerim",
      icon: <FaShoppingBag />,
      isAccordion: true,
      items: [
        {
          id: 1,
          name: "Ödüllerim",
          link: "/profile/orders",
          icon: "fas fa-gift",
        },
        ...(isBrandSalesEnabled
          ? [
              {
                id: 2,
                name: "Ürünlerim",
                link: "/profile/brand-orders",
                icon: "fas fa-shopping-cart",
              },
            ]
          : []),
      ],
    },
    {
      key: "puanlarim",
      title: "Puanlarım",
      icon: <FaStar />,
      isAccordion: true,
      items: [
        {
          id: 3,
          name: "Puan Geçmişim",
          link: "/profile/scores",
          icon: "fas fa-chart-line",
        },
        ...(isCharityScoreEnabled
          ? [
              {
                id: 4,
                name: "İyilik Puan Geçmişim",
                link: "/profile/charity-scores",
                icon: "fas fa-heart",
              },
            ]
          : []),
      ],
    },
    {
      key: "oyunlarim",
      title: "Oyunlarım",
      icon: <FaGamepad />,
      isAccordion: true,
      items: [
        {
          id: 5,
          name: "Fişini Okut",
          link: "/profile/receipt-scan",
          icon: "fas fa-receipt",
        },
        {
          id: 6,
          name: "Kodunu Gir",
          link: "/profile/code-entry",
          icon: "fas fa-file",
        },
        {
          id: 7,
          name: "Fikrini Gönder",
          link: "/profile/send-idea",
          icon: "fas fa-lightbulb",
        },
      ],
    },
    {
      key: "mesajlarim",
      title: "Mesajlarım",
      icon: <FaEnvelope />,
      isAccordion: false,
      link: "/profile/messages",
    },
    {
      key: "favorilerim",
      title: "Favorilerim",
      icon: <FaHeart />,
      isAccordion: false,
      link: "/profile/favourites",
    },
    {
      key: "rozetlerim",
      title: "Rozetlerim",
      icon: <FaMedal />,
      isAccordion: false,
      link: "/profile/badges",
    },
    {
      key: "performans-bilgilerim",
      title: "Performans Bilgilerim",
      icon: <FaChartBar />,
      isAccordion: true,
      items: [
        {
          id: 10,
          name: "Performansım",
          link: "/profile/performance",
          icon: "fas fa-cogs",
        },
        {
          id: 11,
          name: "Yönetim Panelim",
          link: "/profile/dashboard",
          icon: "fas fa-chart-pie",
        },
      ],
    },
    {
      key: "arkadasini-getir",
      title: "Arkadaşını Getir",
      icon: <FaUsers />,
      isAccordion: false,
      link: "/profile/my-references",
    },
    {
      key: "bagli-ustalar",
      title: "Bağlı Ustalar",
      icon: <FaUsers />,
      isAccordion: false,
      link: "/profile/connected-chefs",
    },
    {
      key: "hesap-bilgilerim",
      title: "Hesap Bilgilerim",
      icon: <FaUserCog />,
      isAccordion: true,
      items: [
        {
          id: 12,
          name: "Hesabım ve Şifrem",
          link: "/profile/account-info",
          icon: "fas fa-user",
        },
        {
          id: 13,
          name: "Giriş Detaylarım",
          link: "/profile/login-details",
          icon: "fas fa-list-alt",
        },
        {
          id: 14,
          name: "Fotoğraflarım",
          link: "/profile/photos",
          icon: "fas fa-images",
        },
        {
          id: 15,
          name: "Adreslerim",
          link: "/profile/address",
          icon: "fas fa-map-marker-alt",
        },
        {
          id: 16,
          name: "İletişim Tercihlerim",
          link: "/profile/communication-preferences",
          icon: "fas fa-bell",
        },
      ],
    },
  ];

  const handlePage = (page) => {
    switch (page) {
      case "account-info":
        return <AccountInfo />;
      case "login-details":
        return <LoginDetails />;
      case "scores":
        return <Scores />;
      case "charity-scores":
        return <CharityScore />;
      case "orders":
        return <Orders />;
      case "brand-orders":
        return <BrandOrders />;
      case "address":
        return <Address />;
      case "communication-preferences":
        return <CommunicationPreferences />;
      case "my-references":
        return <MyReferences />;
      case "connected-chefs":
        return <ConnectedChefs />;
      case "information-text":
        return <InformationText />;
      case "photos":
        return <Photos />;
      case "messages":
        return <Messages />;
      case "favourites":
        return <Favourites />;
      case "performance":
        return <Performance />;
      case "dashboard":
        return <LandingPage2 />;
      case "code-entry":
        return <CodeEntry />;
      case "send-idea":
        return <SendIdea />;
      case "receipt-scan":
        return <ReceiptScan />;
      case "receipt-list":
        return <ReceiptList />;
      case "badges":
        return <Badges />;
      default:
        return <AccountInfo />;
    }
  };

  return (
    <React.Fragment>
      <Header />
      <main className="profile-page">
        <section className="bg-blue py-5 mb-5">
          <div className="container">
            <div className="d-flex justify-content-start align-items-center text-decoration-none">
              {profilePhotoItem?.imageUrl ? (
                <img
                  src={profilePhotoItem?.imageUrl}
                  className="bg-white shadow-sm rounded-circle d-flex justify-content-center align-items-center fw-bold"
                  style={{ width: "96px", height: "96px" }}
                  alt="user-profile"
                />
              ) : (
                <div
                  className="shadow-sm rounded-circle bg-gray d-flex flex-col justify-content-center align-items-center"
                  style={{ height: 150, width: 150 }}
                >
                  <FaUser
                    className="text-gray-special"
                    style={{ width: 80, height: 80, color: "#fff" }}
                  />
                </div>
              )}
              <div className="ms-4">
                <h2 className="mb-2 text-white">
                  {profileDetail?.employeeDTO?.name}{" "}
                  {profileDetail?.employeeDTO?.surname}
                </h2>
                <span className="text-white opacity-50">
                  {profileDetail?.score} Puan
                </span>
              </div>
            </div>
          </div>
        </section>
        <section className="mb-sm-10 mb-5">
          <div className="container">
            <div className="row gy-0">
              <div className="col-xl-3 col-lg-4">
                <div className="pe-lg-4 pe-0">
                  <div className="offcanvas offcanvas-start offcanvas-responsive-lg">
                    <div className="offcanvas-header">
                      <h5 className="offcanvas-title">Menü</h5>
                      <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="offcanvas-body shadow-lg px-3 py-4 rounded-3">
                      <div className="accordion" id="profileMenuAccordion">
                        {menuGroups.filter((group) => {
                          switch (group.key) {
                            case "siparislerim": return !hiddenProfileMenus.includes('/profile/orders');
                            case "puanlarim": return !hiddenProfileMenus.includes('/profile/scores');
                            case "oyunlarim": return !hiddenProfileMenus.includes('/profile/receipt-scan');
                            case "mesajlarim": return !hiddenProfileMenus.includes('/profile/messages');
                            case "favorilerim": return !hiddenProfileMenus.includes('/profile/favourites');
                            case "rozetlerim": return !hiddenProfileMenus.includes('/profile/badges');
                            case "performans-bilgilerim": return !hiddenProfileMenus.includes('/profile/performance');
                            case "arkadasini-getir": return !hiddenProfileMenus.includes('/profile/my-references');
                            case "bagli-ustalar": return !hiddenProfileMenus.includes('/profile/connected-chefs');
                            case "hesap-bilgilerim": return !hiddenProfileMenus.includes('/profile/account-info');
                            default: return true;
                          }
                        }).map((group, groupIndex) => (
                          <div
                            key={group.key}
                            className="accordion-item border-0 mb-2"
                          >
                            {group.isAccordion ? (
                              <>
                                <h2
                                  className="accordion-header"
                                  id={`heading-${group.key}`}
                                >
                                  <button
                                    className={`accordion-button ${expandedGroup === group.key ? "" : "collapsed"} bg-transparent border-0 shadow-none p-3 rounded-3`}
                                    type="button"
                                    onClick={() => toggleGroup(group.key)}
                                    style={{
                                      backgroundColor:
                                        expandedGroup === group.key
                                          ? "#f8f9fa"
                                          : "transparent",
                                      color:
                                        expandedGroup === group.key
                                          ? "#4CAF50"
                                          : "inherit",
                                      fontWeight:
                                        expandedGroup === group.key
                                          ? "600"
                                          : "normal",
                                    }}
                                  >
                                    <span
                                      className="me-3"
                                      style={{ width: "24px" }}
                                    >
                                      {group.icon}
                                    </span>
                                    <span className="flex-grow-1 text-start">
                                      {group.title}
                                    </span>
                                  </button>
                                </h2>
                                <div
                                  id={`collapse-${group.key}`}
                                  className={`accordion-collapse collapse ${expandedGroup === group.key ? "show" : ""}`}
                                >
                                  <div className="accordion-body p-0">
                                    <ul className="list-unstyled ms-4">
                                      {group.items.map((item) => (
                                        <li key={item.id} className="mb-2">
                                          <Link
                                            to={item.link}
                                            className="text-decoration-none d-block p-2 rounded-2"
                                            style={{
                                              color:
                                                selectedItem === item.link
                                                  ? "#4CAF50"
                                                  : "inherit",
                                              backgroundColor:
                                                selectedItem === item.link
                                                  ? "#f8f9fa"
                                                  : "transparent",
                                              fontWeight:
                                                selectedItem === item.link
                                                  ? "600"
                                                  : "normal",
                                            }}
                                            onClick={() => {
                                              setSelectedItem(item.link);
                                              setPage(item.link.split("/")[2]);
                                            }}
                                          >
                                            <i
                                              className={`${item.icon} me-3`}
                                              style={{ width: "20px" }}
                                            ></i>
                                            {item.name}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <Link
                                to={group.link}
                                className="text-decoration-none d-block p-3 rounded-3"
                                style={{
                                  color:
                                    selectedItem === group.link
                                      ? "#4CAF50"
                                      : "inherit",
                                  backgroundColor:
                                    selectedItem === group.link
                                      ? "#f8f9fa"
                                      : "transparent",
                                  fontWeight:
                                    selectedItem === group.link
                                      ? "600"
                                      : "normal",
                                }}
                                onClick={() => {
                                  setSelectedItem(group.link);
                                  setPage(group.link.split("/")[2]);
                                }}
                              >
                                <span
                                  className="me-3 d-inline-block"
                                  style={{ width: "24px" }}
                                >
                                  {group.icon}
                                </span>
                                {group.title}
                              </Link>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <a
                    href=".offcanvas"
                    className="btn btn-blue-light text-white rounded-circle p-0 d-flex align-items-center justify-content-center shadow position-fixed bottom-0 end-0 mb-3 me-3"
                    data-bs-toggle="offcanvas"
                  >
                    <i className="fas fa-bars"></i>
                  </a>
                </div>
              </div>
              <div className="col-xl-9 col-lg-8">{handlePage(page)}</div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default ProfileTest;
